/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './labor-incident.reducer';

export const LaborIncidentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const laborIncidentEntity = useAppSelector(state => state.laborIncident.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="laborIncidentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.laborIncident.detail.title">LaborIncident</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.laborIncident.id">Id</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.id}</dd>
          <dt>
            <span id="validLabor">
              <Translate contentKey="tinyMedicRestApp.laborIncident.validLabor">Valid Labor</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.validLabor ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.laborIncident.active">Active</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.laborIncident.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.laborIncident.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.laborIncident.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.laborIncident.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.timestampEntry}</dd>
          <dt>
            <span id="expose">
              <Translate contentKey="tinyMedicRestApp.laborIncident.expose">Expose</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.expose ? 'true' : 'false'}</dd>
          <dt>
            <span id="laborComplete">
              <Translate contentKey="tinyMedicRestApp.laborIncident.laborComplete">Labor Complete</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.laborComplete ? 'true' : 'false'}</dd>
          <dt>
            <span id="laborCompleteTime">
              <Translate contentKey="tinyMedicRestApp.laborIncident.laborCompleteTime">Labor Complete Time</Translate>
            </span>
          </dt>
          <dd>{laborIncidentEntity.laborCompleteTime}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborIncident.obstetricEvent">Obstetric Event</Translate>
          </dt>
          <dd>{laborIncidentEntity.obstetricEvent ? laborIncidentEntity.obstetricEvent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborIncident.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{laborIncidentEntity.pregnancy ? laborIncidentEntity.pregnancy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborIncident.admission">Admission</Translate>
          </dt>
          <dd>{laborIncidentEntity.admission ? laborIncidentEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborIncident.referral">Referral</Translate>
          </dt>
          <dd>{laborIncidentEntity.referral ? laborIncidentEntity.referral.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/labor-incident" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/labor-incident/${laborIncidentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LaborIncidentDetail;
